export const SEARCHTYPE = {
  TALENT: "user",
  COMPANYL: "company",
  PROJECT: "work",
};
